import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./components/theme-provider";
import Header from "./navigation/Header";
import Home from "./Home";
import ScrollTop from "./navigation/ScrollTop";
import Preloader from "./loader/Preloader";
import "./assets/vendor/bootstrap/css/bootstrap.min.css";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/vendor/aos/aos.css";
import "./assets/vendor/glightbox/css/glightbox.min.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
import "./assets/css/main.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "./components/Footer";
import Blog from "./pages/blog/Blog";
import BlogDetails from "./pages/blog/BlogDetails";
import Careers from "./pages/careers/Careers";
import AboutDirector from "./pages/about/AboutDirector";
import AboutOethical from "./pages/about/AboutOethical";
import ContactUs from "./pages/contactUs/ContactUs";
import Team from "./pages/team/Team";
import TermsAndCondition from "./pages/termsAndConditions/TermsAndCondition";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import EduAdminHub from "./pages/products/eduAdminHub/EduAdminHub";
import ProjectDetails from "./pages/projects/ProjectDetails";
import Project from "./pages/projects/Project";
import HRM from "./pages/products/HRM/HRM";
import LMS from "./pages/products/LMS/LMS";

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust this timeout duration as needed

    // Initialize AOS
    AOS.init({ duration: 2000 });

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!loading) {
      const scripts = [
        {
          src: "/assets/vendor/bootstrap/js/bootstrap.bundle.min.js",
          async: true,
        },
        { src: "/assets/vendor/php-email-form/validate.js", async: true },
        { src: "/assets/vendor/aos/aos.js", async: true },
        { src: "/assets/vendor/glightbox/js/glightbox.min.js", async: true },
        { src: "/assets/vendor/swiper/swiper-bundle.min.js", async: true },
        {
          src: "/assets/vendor/imagesloaded/imagesloaded.pkgd.min.js",
          async: true,
        },
        {
          src: "/assets/vendor/isotope-layout/isotope.pkgd.min.js",
          async: true,
        },
      ];

      scripts.forEach((scriptInfo) => {
        const script = document.createElement("script");
        script.src = scriptInfo.src;
        script.async = scriptInfo.async;
        document.body.appendChild(script);
      });

      return () => {
        scripts.forEach((scriptInfo) => {
          const script = document.querySelector(
            `script[src="${scriptInfo.src}"]`
          );
          if (script) {
            document.body.removeChild(script);
          }
        });
      };
    }
  }, [loading]);

  //================= main_return_function ===========//
  return (
    <ThemeProvider defaultTheme="light" storageKey="oethical-theme">
      <Router>
        <ScrollTop />
        <div className="index-page min-h-screen bg-background">
          {loading ? (
            <Preloader />
          ) : (
            <>
              <Header />

              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/aboutOethical" element={<AboutOethical />} />
                <Route path="/aboutDirector" element={<AboutDirector />} />
                <Route path="/eduAdminHub" element={<EduAdminHub />} />
                <Route path="/hrm" element={<HRM />} />
                <Route path="/lms" element={<LMS />} />
                <Route path="/project" element={<Project />} />
                <Route path="/projects/:id" element={<ProjectDetails />} />
                <Route path="/career" element={<Careers />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog-details/:id" element={<BlogDetails />} />
                <Route path="/contactUs" element={<ContactUs />} />
                <Route path="/team" element={<Team />} />
                <Route path="/termAndCondition" element={<TermsAndCondition />} />
                <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
              </Routes>

              <Footer />
            </>
          )}
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
